import Image from "next/image"
import { FC } from "react"




interface IProps {
    width?: number
    height?: number
}


const TrustSymbol: FC<IProps> = ({ width, height }) => {
    return (
        <>
            <li className="bg-white py-xs px-xs">
                <Image
                    width={width ?? "47"}
                    height={height ?? "62"}
                    src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQwIiBoZWlnaHQ9IjM2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCTxwYXRoIGQ9Im0xMjAgMjQzbDk0LTU0IDAtMTA5IC05NCA1NCAwIDEwOSAwIDB6IiBmaWxsPSIjODA4Mjg1Ii8+Cgk8cGF0aCBkPSJtMTIwIDI1NGwtMTAzLTYwIDAtMTE5IDEwMy02MCAxMDMgNjAgMCAxMTkgLTEwMyA2MHoiIHN0eWxlPSJmaWxsOm5vbmU7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO3N0cm9rZS13aWR0aDo1O3N0cm9rZTojMDBhZWVmIi8+Cgk8cGF0aCBkPSJtMjE0IDgwbC05NC01NCAtOTQgNTQgOTQgNTQgOTQtNTR6IiBmaWxsPSIjMDBhZWVmIi8+Cgk8cGF0aCBkPSJtMjYgODBsMCAxMDkgOTQgNTQgMC0xMDkgLTk0LTU0IDAgMHoiIGZpbGw9IiM1ODU5NWIiLz4KCTxwYXRoIGQ9Im0xMjAgMTU3bDQ3LTI3IDAtMjMgLTQ3LTI3IC00NyAyNyAwIDU0IDQ3IDI3IDQ3LTI3IiBzdHlsZT0iZmlsbDpub25lO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6MTU7c3Ryb2tlOiNmZmYiLz4KCTx0ZXh0IHg9IjE1IiB5PSIzMDAiIGZvbnQtc2l6ZT0iMjVweCIgZm9udC1mYW1pbHk9IidCIFlla2FuJyIgc3R5bGU9ImZpbGw6IzI5Mjk1Mjtmb250LXdlaWdodDpib2xkIj7Yudi22Ygg2KfYqtit2KfYr9uM2Ycg2qnYtNmI2LHbjDwvdGV4dD4KCTx0ZXh0IHg9IjgiIHk9IjM0MyIgZm9udC1zaXplPSIyNXB4IiBmb250LWZhbWlseT0iJ0IgWWVrYW4nIiBzdHlsZT0iZmlsbDojMjkyOTUyO2ZvbnQtd2VpZ2h0OmJvbGQiPtqp2LPYqCDZiCDaqdin2LHZh9in24wg2YXYrNin2LLbjDwvdGV4dD4KPC9zdmc+"
                    referrerPolicy="origin"
                    id="nbqeoeuksizpnbqergvjjzpe"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                        window.open(
                            "https://ecunion.ir/verify/salamsakhteman.com?token=2336607625d3327e9c47",
                            "Popup",
                            "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30"
                        )
                    }
                    alt="ecunion"
                />
            </li>

            <li className="bg-white py-xs px-xs">
                <Image
                    width={width ?? "62"}
                    height={height ?? "62"}
                    src="/images/certifications/samandehi.png?id=289237&p=odrfaqgwbsiyodrfqftiyndt"
                    referrerPolicy="origin"
                    id="nbqeoeuksizpnbqergvjjzpe"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                        typeof window !== "undefined" &&
                        window.open(
                            "https://logo.samandehi.ir/Verify.aspx?id=289237&p=uiwkmcsipfvluiwkxlaojyoe",
                            "Popup",
                            "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30"
                        )
                    }
                    alt="logo-samandehi"
                />
            </li>

            <li className="bg-white py-xs px-xs">
                <a
                    referrerPolicy="origin"
                    target="_blank"
                    href="https://trustseal.enamad.ir/?id=253038&amp;Code=6nrQBQ7uzhr3PpeNrEfl"
                >
                    <img
                        referrerPolicy="origin"
                        src="https://Trustseal.eNamad.ir/logo.aspx?id=253038&amp;Code=6nrQBQ7uzhr3PpeNrEfl"
                        alt=""
                        style={{ cursor: "pointer" }}
                        id="6nrQBQ7uzhr3PpeNrEfl"
                        width={width ?? "60"}
                        height={height ?? "62"}
                    />
                </a>
            </li>
        </>
    )
}

export default TrustSymbol